import { render, staticRenderFns } from "./MemberCenterEdit.vue?vue&type=template&id=55ba3e9a&scoped=true&"
import script from "./MemberCenterEdit.vue?vue&type=script&lang=js&"
export * from "./MemberCenterEdit.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterEdit.vue?vue&type=style&index=0&id=55ba3e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba3e9a",
  null
  
)

export default component.exports